import { Button, Column, Form, Grid, Row, TextInput, Tile } from "carbon-components-react";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createCategory } from "../../redux/actions/categoryAction";

function CategoryFormPage({ isLoading }) {
    const history = useHistory()
    const dispatch = useDispatch()
    const [formContent, setFormContent] = useState({
        categoryName: undefined,
        categoryParentId: undefined
    })

    const submitForm = (e) => {
        e.preventDefault()

        dispatch(createCategory(formContent, (_data) => {
            history.push("/categories")
        }))
    }

    return (
        <UIShell breadcrumbs={[
            { name: 'Home', link: "/" },
            { name: 'Categories', link: "/categories" },
            { name: 'Create' }
        ]}>

            <Grid>
                <Row>
                    <Column>
                        <Tile>
                            <Form onSubmit={submitForm}>
                                <TextInput
                                    autoFocus={true}
                                    labelText="Category Name"
                                    value={formContent.categoryName}
                                    onChange={(v) => setFormContent((_state) => ({
                                        ..._state,
                                        categoryName: v.target.value
                                    }))}
                                />

                                <Padding top="1rem">
                                    <Button disabled={isLoading} type="submit" kind="primary">Save</Button>
                                    <Button onClick={() => history.push("/categories")} kind="secondary">Cancel</Button>
                                </Padding>
                            </Form>
                        </Tile>
                    </Column>

                </Row>
            </Grid>

        </UIShell>
    )
}

const mapStateToProps = state => {
    return {
        isLoading: state.uxReducer.isLoading
    }
}

export default connect(mapStateToProps)(CategoryFormPage)